import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import ExpenseType from './ExpenseType';
import LiquidationDifferenceReason from './LiquidationDifferenceReason';
import PaymentMethod from './PaymentMethod';
import VoucherType from './VoucherType';
import CostCenter from './CostCenter';
import GeneralIncomeType from './GeneralIncomeType';
import ManualVoucher from './ManualVoucher';
import Billing from './Billing';
import Detraction from './Detraction';
import ExpenseAuthorizerUser from './ExpenseAuthorizerUser';
import ManualVoucherServiceType from './ManualVoucherServiceType';
import BankAccount from './BankAccount';
import Bank from './Bank';
import TripExpense from './TripExpense';
import SalesTax from './SalesTax';
import ExchangeRate from './ExchangeRate';
import Transaction from './Transaction';
import ExpenseSapMigration from './ExpenseSapMigration';
import ChartOfAccount from './ChartOfAccount';

export default combineReducers({
  UnitHome,
  ExpenseType,
  LiquidationDifferenceReason,
  PaymentMethod,
  VoucherType,
  CostCenter,
  GeneralIncomeType,
  ManualVoucher,
  Billing,
  Detraction,
  ExpenseAuthorizerUser,
  ManualVoucherServiceType,
  Bank,
  BankAccount,
  TripExpense,
  SalesTax,
  ExchangeRate,
  Transaction,
  ExpenseSapMigration,
  ChartOfAccount
});
